<template>
    <!-- 中心优势  -->
    <div class="advantage">
        <h2 class="title">中心优势</h2>
        <div class="text">
            <p class="section">
                服务中心聚焦区域教育公平优质均衡发展，坚持以高标准企业效能服务高标准教育事业发展，不断凝聚和整合区域、学校内外优质教育资源，推动教育科学研究及成果转化，经过多年研究和探索，形成了教育全链生态发展服务体系，协助区域制定顶层规划，践行新政策。强化治理能力，推动新实践。培植特色品牌，凝聚新成果，打造新优势，营造和谐、蓬勃、正向的教育生态，成为教育改革排头兵、创新发展先行者。将区域、学校特色品牌推向全国，进一步提升区域、学校教育教学影响力与专业话语权。
            </p>
            <p class="section">
                服务中心聚焦区域教育公平优质均衡发展，坚持以高标准企业效能服务高标准教育事业发展，不断凝聚和整合区域、学校内外优质教育资源，推动教育科学研究及成果转化，经过多年研究和探索，形成了教育全链生态发展服务体系，协助区域制定顶层规划，践行新政策。强化治理能力，推动新实践。培植特色品牌，凝聚新成果，打造新优势，营造和谐、蓬勃、正向的教育生态，成为教育改革排头兵、创新发展先行者。将区域、学校特色品牌推向全国，进一步提升区域、学校教育教学影响力与专业话语权。
            </p>
            <p class="section">
                服务中心聚焦区域教育公平优质均衡发展，坚持以高标准企业效能服务高标准教育事业发展，不断凝聚和整合区域、学校内外优质教育资源，推动教育科学研究及成果转化，经过多年研究和探索，形成了教育全链生态发展服务体系，协助区域制定顶层规划，践行新政策。强化治理能力，推动新实践。培植特色品牌，凝聚新成果，打造新优势，营造和谐、蓬勃、正向的教育生态，成为教育改革排头兵、创新发展先行者。将区域、学校特色品牌推向全国，进一步提升区域、学校教育教学影响力与专业话语权。
            </p>
        </div>
        <div class="img-warp">
            <img src="../../assets/general/advantage-img.png" alt="" class="image">
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {

            }
        }
    }
</script>

<style lang="less" scoped>
    .advantage {
        // padding: 0 0 80%;
        // background-image: url("../../assets/business/bg.png");
        // background-repeat: no-repeat;
        // background-position: bottom;

        .title {
            font-size: 20px;
            padding: 3.3% 0;
            text-align: center;
        }

        .text {
            font-size: 12px;
            line-height: 2;
            font-weight: 300;
            padding: 0 5.2%;

            .section {
                text-indent: 2em;
                margin-bottom: 1.5%;
            }
        }

        .image {
            margin-top: 5%;
            max-width: 100%;
        }


        @media screen and (min-width:1250px) {
            .title {
                font-size: 26px;
            }

            .text {
                font-size: 15px;
            }

        }

        @media screen and (min-width:1680px) {
            .title {
                font-size: 36px;
            }

            .text {
                font-size: 20px;
            }
        }


    }
</style>